import { render, staticRenderFns } from "./footerMobil.vue?vue&type=template&id=3d18b69c&scoped=true"
import script from "./footerMobil.vue?vue&type=script&lang=js"
export * from "./footerMobil.vue?vue&type=script&lang=js"
import style0 from "./footerMobil.vue?vue&type=style&index=0&id=3d18b69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18b69c",
  null
  
)

export default component.exports